import { Col, Space } from "antd";
import { Form, Formik } from "formik";
import { Translation, useTranslation } from "react-i18next";

import Logo from "assets/images/logo_final_1_1.png";
import { Button } from "components/elements";
import { Input } from "components/form";
import { AuthBackground } from "components/layouts";

import schema from "../schemas/ForgotPasswordSchema";
import styles from "../styles/Forgot.module.css";
import { useEffect, useState } from "react";

const ForgotPassword = ({
  isLoading = false,
  onCancel = () => { },
  doForgotPassword = () => { },
}) => {
  const [timeOut, setTimeOut] = useState(false)
  const [countdown, setCountdown] = useState(60);

  const { t } = useTranslation()

  const handleSubmit = (values) => {
    doForgotPassword(values);
    setTimeOut(true);
  };

  useEffect(() => {
    let timer;
    if (timeOut) {
      setCountdown(60);
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(timer);
            setTimeOut(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer); // ล้าง timer เมื่อ component unmount
  }, [timeOut]);

  return (
    <AuthBackground showLanguageSwitcher>
      <div className={styles.container}>
        <img src={Logo} className={styles.logo} alt="flow hr logo" />
        {/* <p className={styles.header}>
          <Translation>{(t) => t("header_forgot")}</Translation>
        </p>
        <p className={styles.subHeader}>
          <Translation>{(t) => t("receive")}</Translation>
        </p> */}
        <Formik
          initialValues={{
            email: "",
          }}
          onSubmit={handleSubmit}
          validationSchema={schema}
        >
          {({ isValid }) => {
            return (
              <Form className={styles.formContainer}>
                <p className={styles.header}>
                  <Translation>{(t) => t("header_forgot")}</Translation>
                </p>
                {timeOut && (<p className={styles.subHeader}>
                  {t("receive")}  {countdown}  {t("sec")}
                </p>)}
                <Space direction="vertical" size={24}>
                  <Col span={24}>
                    <Input
                      name="email"
                      size="large"
                      type="text"
                      placeholder={t("signin.placeholders.email")}
                      className={styles.input}
                    />
                  </Col>
                  <Col span={24}>
                    <Button
                      className={styles.button}
                      size="large"
                      htmlType="submit"
                      disabled={(!isValid || isLoading) || timeOut}
                    >
                      <p className={styles.textbuttonConfirm}>
                        {t("common.confirm").toUpperCase()}
                      </p>
                    </Button>
                  </Col>
                  <Col span={24}>
                    <Button
                      className={styles.buttonCancel}
                      onClick={onCancel}
                      type="default"
                      size="large"
                      htmlType="button"
                    >
                      <p className={styles.textbuttonCancel}>
                        {t("common.cancel").toUpperCase()}
                      </p>
                    </Button>
                  </Col>
                </Space>
              </Form>
            );
          }}
        </Formik>
      </div>
    </AuthBackground>
  );
};

export default ForgotPassword;
